module.exports = __webpack_public_path__ + "img/chat_type2-2.6ad1afb3.png";